import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { LeftOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import styles from '../../styles.module.css';

const TariffBreakdownSidebar = ({
  context,
  t,
  categories,
  categoryIcons,
  selectedCategory,
  isMobile,
  isMobileMenuVisible,
  setSelectedCategory,
  setIsMobileMenuVisible,
  quickInfo,
  showNavbar,
}) => {
  const [isQuickInfoCollapsed, setIsQuickInfoCollapsed] = useState(true);

  const handleCategoryClick = (category) => {
    if (isMobile) {
      setIsMobileMenuVisible(false);
    }
    setSelectedCategory(category);
  };

  const toggleQuickInfo = () => {
    setIsQuickInfoCollapsed(!isQuickInfoCollapsed);
  };

  return (
    <div
      className={styles.sidebar}
      style={{
        transform: isMobile
          ? isMobileMenuVisible
            ? 'translateY(0)'
            : 'translateY(-100%)'
          : 'translateY(0)',
        opacity: isMobile ? (isMobileMenuVisible ? 1 : 0) : 1,
      }}
    >
      {showNavbar && <h3 className={styles.sidebarTitle}>Categories</h3>}
      <div className={styles.categoryList}>
        {categories.map((category) => (
          <button
            key={category}
            className={`${styles.categoryButton} ${
              selectedCategory === category ? styles.activeCategory : ''
            }`}
            onClick={() => handleCategoryClick(category)}
          >
            <span className={styles.categoryIcon}>
              {categoryIcons[category]}
            </span>
            <span className={styles.categoryName}>{category}</span>
          </button>
        ))}
      </div>
      <div className={styles.quickInfo}>
        <div className={styles.quickInfoHeader} onClick={toggleQuickInfo}>
          <h4>Quick Info</h4>
          <span>
            {isQuickInfoCollapsed ? <DownOutlined /> : <UpOutlined />}
          </span>
        </div>
        {!isQuickInfoCollapsed && (
          <ul className={styles.infoList}>
            {quickInfo.map((info, index) => (
              <li key={index}>{info}</li>
            ))}
          </ul>
        )}
      </div>
      {isMobile && showNavbar && (
        <Link
          to={{ pathname: `/${context.appName}` }}
          className={styles.mobileBackButtonLink}
        >
          <Button
            type="text"
            icon={<LeftOutlined />}
            title={t('label_back_to_bill_calculator')}
            className={styles.mobileBackButton}
          >
            {t('label_back_to_bill_calculator')}
          </Button>
        </Link>
      )}
    </div>
  );
};

export default withTranslation()(TariffBreakdownSidebar);
